module.exports = __webpack_public_path__ + "entry-150bfe9b/aok-photo-c72224acb4697301baa457f18683c549.webp";